/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthAmplifyService } from 'src/app/shared/service/auth-amplify.service';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { GroupSectionComponent } from './group-section/group-section.component';

@Component({
  selector: 'app-profile-switch',
  templateUrl: './profile-switch.component.html',
  styleUrls: ['./profile-switch.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, GroupSectionComponent],
})
export class ProfileSwitchComponent implements OnInit {
  private readonly sharingData = inject(SharingDataService);
  private readonly authAmplifyService = inject(AuthAmplifyService);
  private readonly translationService = inject(TranslationService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);

  test: boolean = false
  isprofileswitchselected: boolean = false
  isMobileMenuVisible: boolean = false
  profileVisible: boolean = false
  isAliasSelected: any
  menuVisible: boolean = true
  userName: any
  userEmail: any
  public ngOnInit(): void {
    this.userName = localStorage.getItem('userName')
    this.userEmail = localStorage.getItem('userEmail')
    this.isAliasSelected = localStorage.getItem("profile")
    this.sharingData.getProfileSwitched()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data) {
          this.isprofileswitchselected = true;
          this._cdr.markForCheck();
        }
      });

    this.sharingData.getProfileSelected()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data) {
          this.isprofileswitchselected = false;
          this._cdr.markForCheck();
        }
      });

  }
  logout() {
    this.authAmplifyService.logout()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(response => {
        window.location.href = response.body.data;
      });
  }

}
